import React, { ReactNode } from "react";

interface AppTableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  children: ReactNode;
}

const AppTableRow: React.FC<AppTableRowProps> = ({ children, className = "", ...props }) => {
  return (
    <tr
      className={`border-b ${className}`}
      {...props}
    >
      {children}
    </tr>
  );
};

export default AppTableRow;